<template>
  <div
    class='x-chip'
    :style="{ backgroundColor: color, fontSize }"
  >
    {{ label }}
  </div>
</template>

<script>
export default {
  name: 'XChip',

  props: {
    color: {
      type: String,
      default: 'grey',
    },
    label: {
      type: String,
      default: ''
    },
    fontSize: {
      type: String,
      default: '16px'
    }
  }
}
</script>

<style lang="scss" scoped>
.x-chip {
  padding: 3px 14px;
  border-radius: 16px;
  color: white;
  width: max-content;
  padding: 3px 8px;
  border-radius: 16px;
  text-transform: uppercase;
}
</style>
